import { getCampaignShareUrl } from './fundStore.js';

export function generateSecretToken() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return `st-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function buildSecretTierUrl(campaignId, secretToken) {
    const base = getCampaignShareUrl(campaignId);
    const token = encodeURIComponent(secretToken);
    if (base.includes('tier=')) {
        return base.replace(/tier=[^&]*/, `tier=${token}`);
    }
    return `${base}&tier=${token}`;
}

/** Tiers visible on public page (private tiers only with matching token) */
export function getPublicRewardTiers(project, secretTierToken = '') {
    const tiers = project.rewardTiers || [];
    return tiers.filter((t) => {
        if (!t.isPrivate) return true;
        return secretTierToken && t.secretToken === secretTierToken;
    });
}

export function findTierBySecretToken(project, token) {
    if (!token) return null;
    return (project.rewardTiers || []).find((t) => t.isPrivate && t.secretToken === token) || null;
}
